export default "__VITE_ASSET__BMcspK3r__"